export default __webpack_public_path__ + "partialFlagNoBorder.svg?b5cc4866a9ff503244dd74e6140ba599";